// Original source: /Users/matteo/projects/apifrom/apifrom-backend/src/shared/config.ts
export class Config {
  static fetchCreditCost: number = 1;
  static browserCreditCost: number = 5;
  static advancedCreditCost: number = 10;
  static transactionCredits: number = 10000;
  static newUserCredits: number = 50;
}
